import React, { useState, useEffect } from "react";
import { Container, Row, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import EditIcon from "../../../images/EditIcon.png";
import DeleteIcon from "../../../images/DeleteIcon.png";
import SearchIcon from "../../../images/SearchIcon.png";
import "react-confirm-alert/src/react-confirm-alert.css";

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";

import "../../../custom-css/datatable.css";

import AssetTypeService from "../../../services/assettype.service";

import "./assets.css";

const ManageAssetsType = () => {
  const [assetTypes, setAssetTypes] = useState([]);

  const [remove, setRemove] = useState(false);

  const [did, setDid] = useState("");

  const [message, setMessage] = useState("");

  const [loadTable, setLoadTable] = useState(false);

  const handleRemoveShow = (e) => {
    setRemove(true);
    setDid(e.target.getAttribute("data-bs-target"));
  };

  const handleRemoveClose = () => {
    setRemove(false);
  };

  const deleteasset = () => {
    AssetTypeService
      .remove(did)
      .then((response) => {
        setMessage(response.data.message);
        setRemove(false);
        console.log(response.data.message);
        setAssetTypes(assetTypes.filter((assetType) => assetType.id !== did));
      })
      .catch((e) => {
        console.log(e);
      });
  };

 

  useEffect(() => {

    AssetTypeService.getAll()
    .then((response) => {
      setAssetTypes(response.data);
    })
    .catch((e) => {
      console.log(e);
    });

    if (!$.fn.DataTable.isDataTable("#table")) {
      function filterGlobal() {
        $("#table")
          .DataTable()
          .search(
            $("#global_filter").val(),
            $("#global_regex").prop("checked"),
            $("#global_smart").prop("checked")
          )
          .draw();
      }
      function filterColumn(i) {
        $("#table")
          .DataTable()
          .column(i)
          .search(
            $("#col" + i + "_filter").val(),
            $("#col" + i + "_regex").prop("checked"),
            $("#col" + i + "_smart").prop("checked")
          )
          .draw();
      }

      $(document).ready(function () {
        setTimeout(function () {
          $("#table").DataTable({
            pagingType: "full_numbers",
            responsive: true,
            pageLength: 10,
            processing: true,
            select: true,
            bDestroy: true,

            lengthMenu: [
              [10, 20, 30, 50, -1],
              [10, 20, 30, 50, "All"],
            ],
            columnDefs: [
              {
                targets: 0,
                render: function (data, type, row, meta) {
                  return type === "export" ? meta.row + 1 : data;
                },
              },
            ],
          });

          $("input.global_filter").on("keyup click", function () {
            filterGlobal();
          });

          $("input.column_filter").on("keyup click", function () {
            filterColumn($(this).parents("tr").attr("data-column"));
          });
          
          setLoadTable(true);
        }, 1000);
      });
    }
  }, []);

  return (
    <>
      <Container fluid>
        <Row>
          <div className="assetsInfo">
            <div className="message">{message}</div>
            <div className={loadTable ? 'table-actions active' : 'table-actions' }>
              <label htmlFor="">
                <input
                  type="text"
                  className="global_filter"
                  id="global_filter"
                  placeholder="Search"
                />
                <img src={SearchIcon} alt="" />
              </label>
              <Button className="custom-btn">
                <Link to={"/ManageAssets"}>View Assets</Link>
              </Button>
              <Button className="custom-btn">
                <Link to={"/ManageAssetsType"}>View Asset Types</Link>
              </Button>
              <Button className="custom-btn">
                <Link to={"/AddAsset"}>Add Asset</Link>
              </Button>
              <Button className="custom-btn">
                <Link to={"/AddAssetType"}>Add Asset Type</Link>
              </Button>
            </div>
            <div className="assetsInfoTable">
              <div className="table-responsive">
                <table id="table" className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Name</th>
                      <th>Note</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(assetTypes)
                      ? assetTypes.map((assetType, index) => {
                          return (
                            <tr key={assetType.id}>
                              <td>{index + 1}</td>
                              <td>{assetType.name}</td>
                              <td>{assetType.note}</td>
                              <td>
                                <div className="flex">
                                  <Link to={"/EditAssetType/" + assetType.id}>
                                    <img
                                      src={EditIcon}
                                      alt="Edit Asset Type"
                                      title="Edit Asset Type"
                                      style={{ width: "18px", height: "18px" }}
                                    />
                                  </Link>
                                  <img
                                    onClick={handleRemoveShow}
                                    id="deleteAssetType"
                                    data-bs-target={assetType.id}
                                    src={DeleteIcon}
                                    alt="Delete Asset Type"
                                    title="Delete Asset Type"
                                    style={{ width: "18px", height: "18px" }}
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Row>
      </Container>
      <Modal show={remove} onHide={handleRemoveClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Asset Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this asset type.</p>
          <div className="flex">
            <Button onClick={deleteasset}>Yes</Button>
            <Button variant="danger" onClick={handleRemoveClose}>
              No
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ManageAssetsType;
